import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material';
import Navigation from './components/Navigation';
import Dashboard from './pages/Dashboard';
import ReflectionZone from './pages/ReflectionZone';
import AuthPage from './pages/AuthPage';
import PrivateRoute from './components/PrivateRoute';
import { GoalsProvider } from './contexts/GoalsContext';
import { MomentumProvider } from './contexts/MomentumContext';
import { ReflectionsProvider } from './contexts/ReflectionsContext';
import Friends from './pages/Friends';
import { UsersProvider } from './contexts/UsersContext';
import { NotificationsProvider } from './contexts/NotificationsContext';

const theme = createTheme({
  palette: {
    primary: {
      main: '#4CAF50', // Fresh green
    },
    secondary: {
      main: '#2196F3', // Soothing blue
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <NotificationsProvider>
          <UsersProvider>
            <GoalsProvider>
              <ReflectionsProvider>
                <MomentumProvider>
                  <Navigation />
                  <Routes>
                    <Route path="/auth" element={<AuthPage />} />
                    <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
                    <Route path="/reflection" element={<PrivateRoute><ReflectionZone /></PrivateRoute>} />
                    <Route path="/friends" element={<PrivateRoute><Friends /></PrivateRoute>} />
                  </Routes>
                </MomentumProvider>
              </ReflectionsProvider>
            </GoalsProvider>
          </UsersProvider>
        </NotificationsProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App; 